<template>
  <div class="subscr-preview-base" :style="styles">
    <h4 v-html="resultData.result_title"></h4>
    <p v-html="resultData.result_text"></p>
    <div class="btn-wrap">
      <div class="inner">
        <lp-base-button
          design="fill"
          :label="buttonFace"
          :color-scheme="colorData"
          @clicked="onBtnClick"
        />
        <p>※ここから先は月額登録でご覧いただけます</p>
      </div>
      <div class="bluerd-text">あなたは、人生を自分らしく生きるために生まれてきました。周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。しかし、そのためにストレスをたるはずです。<br><br>あなたは、人生を自分らしく生きるために生まれてきました。<br>周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。<br><br>あなたは、人生を自分らしく生きるために生まれてきました。周りの人たちの中には、自分の気持ちや欲望を抑えて過ごしている人が大勢いるはずです。しかし、そのためにストレスをたるはずです。</div>
      <!-- <img class="bluerd-text" src="/static/img/recommend/lp/common/preview_blured_text.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'SubscrFortunePreview',
  components: {
    LpBaseButton,
  },
  props: {
    buttonFace: {
      type: String,
      default: '続きを見る（月額528円）'
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    resultData: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      require: true,
    },
    colorData: {
      type: Object,
      default(){
        return {
          head: 'black',
          font: 'black',
          previewBg: 'white',
          previewBorder: 'black',
        }
      }
    },
    testCase: {
      type: String,
      default: '',
    },
  },
  computed: {
    styles(){
      return {
        '--head': this.colorData.head,
        '--font': this.colorData.font,
        '--preview-bg': this.colorData.previewBg,
        '--preview-border': this.colorData.previewBorder,
      }
    },
  },
  methods: {
    onBtnClick(){
      const ab = /^(B)$/.test(this.testCase) ? this.testCase : ''
      const param = {
        'event_category': `LP${this.lpId}basicresult-continue-subsc-button`,
        'event_label': ab + this.resultData.menu_id
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(this.resultData.link_url)
    },
  },
}
</script>

<style scoped lang="scss">
$l_col_head: var(--head);
$l_col_font: var(--font);
$l_col_preview_bg: var(--preview-bg);
$l_col_preview_border: var(--preview-border);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.subscr-preview-base {
  color: $l_col_font;
  background: $l_col_preview_bg;
  border: 1px solid $l_col_preview_border;
  border-radius: 10px;
  width: 100%;
  padding: 24px 20px;
  h4 {
    color: $l_col_head;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 10px;
  }
  > p {
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    margin: 0 0 10px;

    & /deep/ .tarot-img{
      margin: 20px auto !important;
    }
  }
  .btn-wrap {
    background: url();
    background-size: cover;
    color: #303030;
    position: relative;
    width: 100%;
    height: 0;
    padding-top: unquote('min(49.34%, 145px)');
    .inner {
      width: 100%;
      max-width: 320px;
      position: absolute;
      z-index: 10;
      top: 50%;
      left: 0;
      right: 0;
      margin: auto;
      transform: translateY( -50% );
      > p {
        margin: 8px -10px 0;
        font-weight: bold;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #303030;
      }
      /deep/ .baseButton__button {
        min-width: auto;
      }
    }
    .bluerd-text {
      position: absolute;
      width: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;
      font-size: 14px;
      line-height: 21px;
      text-align: justify;
      filter: blur(6px);
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/SubscrFortunePreview.vue